import * as R from "ramda";

export const lookupValueById = (prop, selected, items) => {
  //return the first matching item
  return R.filter(R.propEq(prop, String(selected)), items)[0]
    ? R.filter(R.propEq(prop, String(selected)), items)[0]
    : {};
};

export const eqValues = R.compose(R.isEmpty, R.symmetricDifference);
